"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackConsoleError = trackConsoleError;
const browser_core_1 = require("@datadog/browser-core");
function trackConsoleError(errorObservable) {
    const subscription = (0, browser_core_1.initConsoleObservable)([browser_core_1.ConsoleApiName.error]).subscribe((consoleLog) => errorObservable.notify(consoleLog.error));
    return {
        stop: () => {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map